import {Flex, Input, Select, theme, Typography} from 'antd';
import React from 'react';

const {Text} = Typography;

// Scoped to Pages/SearchMember — a small antd label+input/select field, standing
// in for the shared (MUI-based) Components/CustomTextInput on this page only.
// formik.handleChange only needs `e.target.{name,value}`, so antd's Select
// (which reports a raw value, not an event) is bridged into that same shape.
interface AntSearchFieldProps {
  label: string;
  name: string;
  value?: string;
  onChange: (e: {target: {name: string; value: string}}) => void;
  disabled?: boolean;
  options?: string[];
}

const AntSearchField: React.FC<AntSearchFieldProps> = ({
  label,
  name,
  value,
  onChange,
  disabled,
  options,
}) => {
  const {token} = theme.useToken();
  return (
    <Flex vertical gap={6} style={{flex: 1, minWidth: 0}}>
      <Text style={{fontSize: 12, fontWeight: 600, color: token.colorTextSecondary}}>{label}</Text>
      {options ? (
        <Select
          value={value || undefined}
          disabled={disabled}
          allowClear
          onChange={(val) => onChange({target: {name, value: val ?? ''}})}
          options={options.map((option) => ({label: option, value: option}))}
        />
      ) : (
        <Input name={name} value={value || ''} disabled={disabled} onChange={onChange} />
      )}
    </Flex>
  );
};

export default AntSearchField;
